/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ExplainResourceAccessSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * The kind of resource to explain.
 */
export const ResourceKind = {
  Mcp: "mcp",
} as const;
/**
 * The kind of resource to explain.
 */
export type ResourceKind = ClosedEnum<typeof ResourceKind>;

export type ExplainResourceAccessRequest = {
  /**
   * The kind of resource to explain.
   */
  resourceKind: ResourceKind;
  /**
   * The resource to explain.
   */
  resourceId: string;
  /**
   * The organization member whose access to explain.
   */
  userId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ExplainResourceAccessSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ExplainResourceAccessSecurity$outboundSchema: z.ZodMiniType<
  ExplainResourceAccessSecurity$Outbound,
  ExplainResourceAccessSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function explainResourceAccessSecurityToJSON(
  explainResourceAccessSecurity: ExplainResourceAccessSecurity,
): string {
  return JSON.stringify(
    ExplainResourceAccessSecurity$outboundSchema.parse(
      explainResourceAccessSecurity,
    ),
  );
}

/** @internal */
export const ResourceKind$outboundSchema: z.ZodMiniEnum<typeof ResourceKind> = z
  .enum(ResourceKind);

/** @internal */
export type ExplainResourceAccessRequest$Outbound = {
  resource_kind: string;
  resource_id: string;
  user_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ExplainResourceAccessRequest$outboundSchema: z.ZodMiniType<
  ExplainResourceAccessRequest$Outbound,
  ExplainResourceAccessRequest
> = z.pipe(
  z.object({
    resourceKind: ResourceKind$outboundSchema,
    resourceId: z.string(),
    userId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      resourceKind: "resource_kind",
      resourceId: "resource_id",
      userId: "user_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function explainResourceAccessRequestToJSON(
  explainResourceAccessRequest: ExplainResourceAccessRequest,
): string {
  return JSON.stringify(
    ExplainResourceAccessRequest$outboundSchema.parse(
      explainResourceAccessRequest,
    ),
  );
}
